import Emitter from 'es6-event-emitter';
import msgpack from 'msgpack-lite';
import qs      from 'qs';
import              'whatwg-fetch';

/**
 * サーバー同期（ajax）
 *
 * @package     croco-fw
 * @author      Yujiro Takahashi <yujiro@cro-co.co.jp>
 */
class Sync extends Emitter {
    /**
     * コンストラクタ
     *
     * @access public
     * @return void
     */
    constructor() {
        super();

        this.MSGPACK_TYPE = "application/x-msgpack";
        this.JSON_TYPE = "application/json";
    }

    /**
     * GET
     *
     * @access public
     * @return this
     */
    get (url, data = null) {
        if (null != data) {
            url += qs.stringify(data, true);
        }

        return fetch(url, {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function(response) {
            const contentType = response.headers.get('Content-Type');
            if (contentType.startsWith(this.MSGPACK_TYPE)) {
                return this.decode(response.body);
            } else {
                return response.json();
            }
        }.bind(this)).catch(function(error) {
            console.log(error)
        }.bind(this));
    }

    /**
     * POST
     *
     * @access public
     * @return this
     */
    post (url, data) {
        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: qs.stringify(data)
        }).then((response) => {
            const contentType = response.headers.get('Content-Type');
            if (contentType.startsWith(this.MSGPACK_TYPE)) {
                return this.decode(response.body, response.headers.get('Content-Length'));
            } else {
                return response.json();
            }
        }).catch((error) => {
            console.log(error)
        });
    }

    /**
     * stream data decoder
     *
     * @access public
     * @return this
     */
    decode(stream, length) {
        let size = length ? length : 4096;
        let reader = stream.getReader();
        let buff = new Uint8Array(size);

        return reader.read().then(function readChunk({ done, value }) {
            if (done) {
                return msgpack.decode(buff);
            }
            buff.set(value);

            return reader.read().then(readChunk);
        });
    }
} // class Sync

export default Sync;